var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"cotent",attrs:{"id":"pdfContent"}}),_c('div',{staticClass:"footer"},[_c('van-button',{attrs:{"type":"primary","block":""},on:{"click":_vm.resign}},[_vm._v("重新签署")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }